
import { MainLayout } from "@/components/layout/MainLayout";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { useState } from "react";

export default function CoursesVideos() {
  const [videos] = useState([
    {
      id: 1,
      title: "Εισαγωγή στη Λογιστική για Επιχειρήσεις",
      duration: "22:45",
      date: "15/06/2023",
      description: "Βασικές έννοιες λογιστικής και οικονομικών καταστάσεων για νέους επιχειρηματίες.",
      credits: 15,
      thumbnail: "https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=500&h=280&fit=crop"
    },
    {
      id: 2,
      title: "Φορολογικές Υποχρεώσεις και Φοροαπαλλαγές",
      duration: "35:20",
      date: "22/07/2023",
      description: "Πλήρης οδηγός για τις φορολογικές υποχρεώσεις επιχειρήσεων και ελεύθερων επαγγελματιών.",
      credits: 20,
      thumbnail: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500&h=280&fit=crop"
    },
    {
      id: 3,
      title: "Τεχνολογικές Λύσεις για Λογιστές",
      duration: "18:30",
      date: "10/08/2023",
      description: "Εργαλεία και λογισμικό που βελτιώνουν την παραγωγικότητα των λογιστικών γραφείων.",
      credits: 12,
      thumbnail: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=500&h=280&fit=crop"
    },
    {
      id: 4,
      title: "Προχωρημένες Τεχνικές Λογιστικής Ανάλυσης",
      duration: "42:15",
      date: "05/09/2023",
      description: "Μεθοδολογίες και πρακτικές για την αποτελεσματική διαχείριση πολύπλοκων οικονομικών αναφορών.",
      credits: 25,
      thumbnail: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7?w=500&h=280&fit=crop"
    }
  ]);

  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Βίντεο Μαθήματα</h1>
        <p className="text-muted-foreground mb-6">
          Εδώ θα βρείτε εκπαιδευτικά βίντεο για λογιστικά και φορολογικά θέματα.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videos.map((video) => (
            <div key={video.id} className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow">
              <div className="relative">
                <AspectRatio ratio={16/9}>
                  <img 
                    src={video.thumbnail} 
                    alt={`Προεπισκόπηση: ${video.title}`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 rounded-full bg-primary/80 flex items-center justify-center">
                      <PlayIcon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                </AspectRatio>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-sm px-2 py-1 rounded-md flex items-center">
                  <Clock className="h-3 w-3 mr-1" />
                  {video.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold mb-1">{video.title}</h3>
                <p className="text-xs text-muted-foreground mb-3">
                  Ημ/νία: {video.date}
                </p>
                <p className="text-sm text-muted-foreground mb-3">
                  {video.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">{video.credits} Credits</span>
                  <Button variant="link" className="text-primary p-0 h-auto">Παρακολούθηση</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

function PlayIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  );
}
